import VideoSection from 'elem/compPage/delta-3-max-series/pages/product/components/Common/VideoSection';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

const CoverSection1: React.FC = () => {
    const { t } = useLang('CoverSection1');

    return (
        <div className={`page-coverSection1 range2 ${styles.CoverSection1} GtmModuleData-section`} data-section-id="d3c-CoverSection1">
            <VideoSection
                sectionId="videoSection1"
                triggerSelector="#videoSection1"
                videoSrc="https://websiteoss.ecoflow.com/upload/video/1759042032809/01.mp4"
                posterSrc="https://websiteoss.ecoflow.com/figma-uploads/1758710442515-men9v8-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA_Cutdown.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
            />
        </div>
    );
};

export default CoverSection1;
